import React from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import colorMap from './measurementColors';

const PieChartWithData = ({ data }: any) => {
  // Extract data entries for the pie chart.
  // Each key that ends with '%' represents a category in the pie chart.
  const chartData = Object.keys(data)
    .filter(key => key.endsWith('%')) // find keys that represent percentages
    .map((key) => {
      const title = key.replace(' %', ''); // remove the ' %' to get the title
      const firstWord = key.split(' ')[0].toLowerCase();
      const value = data[key];

      // Return the data in the format expected by PieChart
      return {
        title,
        value,
        color: colorMap[firstWord] || '#d1d5db' // Use a default color if not defined
      };
    });

  return (
    <div className="p-8">
      <PieChart
        data={chartData}
        label={({ dataEntry }) => `${dataEntry.title}: ${(dataEntry.percentage).toFixed(2)}%`}
        labelStyle={{
          fontSize: '5px',
          fontFamily: 'sans-serif',
          color: "#ffffff"
        }}
        labelPosition={50}
      />
    </div>
  );
};

export default PieChartWithData;
